module.exports = __webpack_public_path__ + "static/media/directionIcon.928361e8.png";